type SectionHeadingProps = {
  index: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  index,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  return (
    <div className={align === "center" ? "text-center" : ""}>
      <div
        className={`flex items-center gap-3 ${
          align === "center" ? "justify-center" : ""
        }`}
      >
        <span className="font-label text-xs tracking-[0.3em] text-primary-600">
          {index}
        </span>
        <span className="h-px w-10 bg-primary-300" />
      </div>
      <h2 className="font-heading mt-3 text-2xl md:text-4xl font-bold text-foreground-950">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 max-w-3xl text-sm md:text-base leading-relaxed text-foreground-600">
          {desc}
        </p>
      ) : null}
    </div>
  );
}